"use strict";
exports.__esModule = true;
exports.reflect = exports.AlgorandOperationTypeEnum = void 0;
exports.AlgorandOperationTypeEnum = {
    PAYMENT: 0,
    ASSET_OPT_IN: 7,
    ASSET_OPT_OUT: 8,
    ASSET_TRANSFER: 9
};
var reflect = function (declare) {
    declare("AlgorandAccount", {
        methods: {
            createTransaction: {
                returns: "AlgorandTransaction"
            },
            broadcastRawTransaction: {
                params: ["hex"]
            },
            getFeeEstimate: {
                params: ["AlgorandTransaction"],
                returns: "Amount"
            },
            getAssetsBalances: {
                returns: ["AlgorandAssetAmount"]
            },
            getPendingRewards: {
                returns: "Amount"
            },
            getTotalRewards: {
                returns: "Amount"
            },
            getSpendableBalance: {
                returns: "Amount"
            },
            isAmountValid: {},
            hasAsset: {}
        }
    });
    declare("AlgorandAssetAmount", {
        njsUsesPlainObject: true,
        methods: {
            getAssetId: {
                njsField: "assetId"
            },
            getAmount: {
                njsField: "amount"
            }
        }
    });
    declare("AlgorandOperation", {
        methods: {
            getTransaction: {
                returns: "AlgorandTransaction"
            },
            getAlgorandOperationType: {},
            getAssetAmount: {},
            getRewards: {}
        }
    });
    declare("AlgorandTransaction", {
        methods: {
            getId: {},
            setSender: {},
            setFee: {},
            setNote: {},
            getType: {},
            setPaymentInfo: {
                params: ["AlgorandPaymentInfo"]
            },
            setAssetTransferInfo: {
                params: ["AlgorandAssetTransferInfo"]
            },
            serialize: {
                returns: "hex"
            },
            setSignature: {
                params: ["hex"]
            },
            getFee: {},
            getRound: {},
            getSender: {},
            getAssetTransferInfo: {
                returns: "AlgorandAssetTransferInfo"
            },
            getNote: {}
        }
    });
    declare("AlgorandPaymentInfo", {
        njsUsesPlainObject: true,
        statics: {
            init: {
                params: [null, null, null, null],
                returns: "AlgorandPaymentInfo",
                njsInstanciateClass: [
                    {
                        recipientAddress: 0,
                        amount: 1,
                        closeAddress: 2,
                        closeAmount: 3
                    },
                ]
            }
        }
    });
    declare("AlgorandAddress", {
        statics: {
            fromPublicKey: {
                params: ["hex"],
                njsBuggyMethodIsNotStatic: true
            }
        }
    });
    declare("AlgorandAssetTransferInfo", {
        njsUsesPlainObject: true,
        statics: {
            init: {
                params: [null, null, null, null, null, null],
                returns: "AlgorandAssetTransferInfo",
                njsInstanciateClass: [
                    {
                        assetId: 0,
                        amount: 1,
                        recipientAddress: 2,
                        closeAddress: 3,
                        clawedBackAddress: 4,
                        closeAmount: 5
                    },
                ]
            }
        },
        methods: {
            getAssetId: {
                njsField: "assetId"
            },
            getAmount: {
                njsField: "amount"
            },
            getRecipientAddress: {
                njsField: "recipientAddress"
            },
            getCloseAddress: {
                njsField: "closeAddress"
            },
            getCloseAmount: {
                njsField: "closeAmount"
            }
        }
    });
    return {
        OperationMethods: {
            asAlgorandOperation: {
                returns: "AlgorandOperation"
            }
        },
        AccountMethods: {
            asAlgorandAccount: {
                returns: "AlgorandAccount"
            }
        }
    };
};
exports.reflect = reflect;
//# sourceMappingURL=types.js.map